<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <span>Großhandel</span>
            </template>
        </navbar>


        <b-card v-if="items.length > 0">
            <div class="table-responsive">
                <b-table-simple>
                    <b-thead>
                        <b-tr>
                            <b-th>#</b-th>
                            <b-th>NAME</b-th>
                            <b-th>ANREDE</b-th>
                            <b-th>FIRMA</b-th>
                            <b-th>Land</b-th>
                            <b-th>TELEFON</b-th>
                            <b-th>EMAIL</b-th>
                            <b-th>WEBSITE</b-th>
                            <b-th>DATE</b-th>
                            <th></th>
                        </b-tr>
                    </b-thead>

                    <b-tbody>
                        <b-tr v-for="(item,index) in items" :key="index">
                            <b-td>{{++index}}</b-td>
                            <b-td>{{ item.name }}</b-td>
                            <b-td>{{ item.gender }}</b-td>
                            <b-td>{{ item.company }}</b-td>
                            <b-td>{{ item.country }}</b-td>
                            <b-td>{{ item.tel }}</b-td>
                            <b-td>{{ item.email }}</b-td>
                            <b-td>
                                <a target="_blank" :href="item.website">{{ item.website }}</a>
                            </b-td>
                            <b-td>{{ item.date }}</b-td>
                            <b-td>
                                <b-link :to="{name:'CustomerDetails',params:{'customerid':item.id}}" class="btn btn-success mr-1">
                                    {{$t('details')}}
                                </b-link>

                                <b-button variant="danger" @click="deleteCustomer(item.id)">delete</b-button>
                            </b-td>

                        </b-tr>
                    </b-tbody>

                </b-table-simple>
            </div>
        </b-card>

    </div>
</template>

<script>

    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'
    import Navbar from "../Partials/Navbar";


    export default {
        name: "Index",
        components: {Navbar},
        data() {
            return {
                items: [],
            }
        },
        methods: {
            getCustomers() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'customer/index')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.items = response.data.data.customers;
                        } else {
                            Notificaion.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            deleteCustomer(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'customer/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.getCustomers();
                                Notificaion.success(response.data.message)

                            } else {
                                Notificaion.error(response.data.message)

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
        },
        created() {
            this.getCustomers();
        }
    }
</script>

<style scoped>

</style>